import {SvgIcon} from '@mui/material';
import type {Components} from '@mui/material/styles';
import CheckboxInactiveIcon from '@/modules/shared/ui/kit/icons/CheckboxInactive';
import CheckboxActiveIcon from '@/modules/shared/ui/kit/icons/CheckboxActive';

export const MuiCheckbox: Components['MuiCheckbox'] = {
  defaultProps: {
    icon: <SvgIcon component={CheckboxInactiveIcon} />,
    checkedIcon: <SvgIcon component={CheckboxActiveIcon} />,
    color: 'secondary',
  },
  styleOverrides: {
    root: {
      padding: 8,
    },
  },
};
